// extracted by mini-css-extract-plugin
module.exports = {"icon-stat-link-wrapper":"icon-stat-link-wrapper__hKwEp","icon-stat":"icon-stat__q_Q35"};